import { EFConnectableSide } from '@foblex/flow';

export enum ViewPortType {
  INPUT = 'input',
  OUTPUT = 'output',
  INPUT_OUTPUT = 'input-output'
}

export interface ViewPort {
  id: string;
  type: ViewPortType;
  role?: string;
  multiple?: boolean;
  label?: string;
  icon?: string;
  data?:any;
  allowedConnections?: string[];
  position: EFConnectableSide;
  internal?: boolean;
  cssClassName?: string;
  order?: number;
}
